import { combineReducers } from 'redux';

import user from './user';
import conforms from './conforms';
import link from './link';


export default combineReducers({
  user,
  conforms,
  link,
});
